import * as types from './user-settings.types';
import * as constants from './user-settings.constants';
import { IUserSetting, IUpdateUserSettingsData } from '../../../resource/user-settings/user-settings.types';
import { DropResult } from 'react-beautiful-dnd';

export const getUserSettings = (): types.IGetUserSettings => ({
  type: constants.GET_USER_SETTINGS,
});

export const updateUserSettings = (userSettings: IUpdateUserSettingsData): types.IUpdateUserSettings => ({
  type: constants.UPDATE_USER_SETTINGS,
  payload: userSettings,
});

export const storeUserSettings = (userSettings: IUserSetting): types.IStoreUserSettings => ({
  type: constants.STORE_USER_SETTINGS,
  payload: userSettings,
});

export const storeUserWidgetVisibility = (
  key: types.IWidget['key'],
  visibility: boolean,
): types.IStoreUserWidgetVisibility => ({
  type: constants.STORE_USER_WIDGETS,
  payload: { key, visibility },
});

export const clearUserSettings = (): types.IClearUserSettings => ({
  type: constants.CLEAR_USER_SETTINGS,
});

export const reorderUserWidgets = (result: DropResult): types.IReorderUserWidgets => ({
  type: constants.REORDER_USER_WIDGETS,
  payload: result,
});

export const updateUserWidgetSize = (key: types.IWidget['key'], size: string): types.IUpdateUserWidgetSize => ({
  type: constants.UPDATE_USER_WIDGET_SIZE,
  payload: { key, size },
});
